'use client'

import { isMobileDevice } from '@/core/lib/utils/is-mobile-device'
import { domAnimation, LazyMotion, motion, MotionProps } from 'framer-motion'
import { ComponentPropsWithoutRef, createElement, JSX, RefObject } from 'react'

type CustomMotionProps<Tag extends keyof JSX.IntrinsicElements> = MotionProps &
  Omit<ComponentPropsWithoutRef<Tag>, keyof MotionProps> & {
    type?: Tag
    ref?: RefObject<HTMLElement | null>
  }

export const Motion = <Tag extends keyof JSX.IntrinsicElements>({
  type,
  children,
  className,
  ...props
}: CustomMotionProps<Tag>) => {
  const isMobile = isMobileDevice()
  if (isMobile) {
    const Component = type ?? 'div'
    return createElement(
      Component as React.ElementType,
      {
        className,
        ...props,
      },
      children as React.ReactNode,
    )
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Component = type ? (motion as any)[type] : motion.div
  return (
    <LazyMotion features={domAnimation}>
      <Component className={className} {...props}>
        {children}
      </Component>
    </LazyMotion>
  )
}
